import { lazy } from 'react';

export const AdminSubscriptionsPage = lazy(() => import('./AdminSubscriptionsPage'));
